<template>
    <div>
        <div v-if=" !(['timing', 'manual'].includes(triggerType))">
            <button class="button is-link mr-2" type="button" @click=" $modal.show('simulation-selection') ">Run
                Simulation
            </button>
            <modal
                v-cloak
                name="simulation-selection"
                :adaptive="true"
                :scrollable="true"
                :width="'500px'"
                :max-width="500"
                :height="'auto'">
                <div class="is-padded">
                    <button type="button" class="delete is-top-right has-margins-05"
                            aria-label="close simulation selection window"
                            @click=" $modal.hide('simulation-selection') "></button>
                    <confirm-form
                        method="POST"
                        text="This will simulate the trigger in order to test if it is working. No permanent actions will result from this test."
                        :action=" routeTriggerTest "
                    >
                        <div class="field py-3">
                            <label for="simulation_id" class="label">Which {{ triggerName }} should we simulate
                                {{ triggerType === 'updated' ? 'an "updated"' : 'a ' + triggerType }} event on?</label>
                            <p class="control has-icons-left">
                                <input class="input" id="simulation_id" name="simulation_id" type="number" step="1" min="0"
                                       required/>
                                <span class="icon is-small is-left"><i class="fa-solid fa-hashtag"></i></span>
                            </p>
                            <p class="help">
                                Enter the database ID of the item you'd like to simulate being {{ triggerType }}.
                            </p>
                        </div>

                        <div class="field py-3" v-if=" triggerType === 'updated' ">
                            <label>Which data should be simulated as updated?</label>
                            <br>
                            <div v-for="(u, i) in updatedData" class="my-2">
                                <div class="control has-icons-left">
                                    <div class="select">
                                        <select name="updatedProperty[]" v-model="updatedData[i].property" @change="updateUpdatedData(i)">
                                            <option v-for=" property in Object.keys(triggerConfig['properties']) "
                                                    :value=" property ">
                                                {{ property }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="icon is-left">
                                        <i class="fa-solid fa-list"></i>
                                    </div>
                                </div>
                                <div>
                                    <div v-if="updatedData[i].property && triggerConfig['properties'][updatedData[i].property]['type'].includes('datetime')">
                                        <xero-datetime name="updatedValues[]" v-model="updatedData[i].value"></xero-datetime>
                                    </div>
                                    <div v-else-if="updatedData[i].property && triggerConfig['properties'][updatedData[i].property]['type'].includes('date')">
                                        <xero-date name="updatedValues[]" v-model="updatedData[i].value"></xero-date>
                                    </div>
                                    <div v-else-if="updatedData[i].property && triggerConfig['properties'][updatedData[i].property]['type'].includes('integer')">
                                        <input name="updatedValues[]" type="number" step="1" min="1" class="input"
                                               placeholder="Simulated New Value" v-model="updatedData[i].value">
                                    </div>
                                    <div v-else-if="updatedData[i].property && triggerConfig['properties'][updatedData[i].property]['type'].includes('number')">
                                        <input name="updatedValues[]" type="text" class="input" placeholder="Simulated New Value"
                                               v-model="updatedData[i].value">
                                    </div>
                                    <div v-else-if="updatedData[i].property">
                                        <input name="updatedValues[]" type="text" class="input" placeholder="Simulated New Value"
                                               v-model="updatedData[i].value">
                                    </div>
                                </div>

                            </div>
                            <div>
                                <button type="button" class="button is-small" @click=" addUpdatedProperty ">Add +</button>
                            </div>
                        </div>

                        <button class="button is-info" type="submit">Run Simulation</button>
                    </confirm-form>
                </div>
            </modal>
        </div>



        <div v-else-if=" triggerType === 'timing' ">
            <button class="button is-link mr-2" type="button" @click=" $modal.show('simulation-selection') ">Run
                Simulation
            </button>
            <modal
                v-cloak
                name="simulation-selection"
                :adaptive="true"
                :scrollable="true"
                :width="'500px'"
                :max-width="500"
                :height="'auto'">
                <div class="is-padded">
                    <button type="button" class="delete is-top-right has-margins-05"
                            aria-label="close simulation selection window"
                            @click=" $modal.hide('simulation-selection') "></button>
                    <confirm-form
                        method="POST"
                        text="This will simulate the trigger in order to test if it is working. No permanent actions will result from this test."
                        :action=" routeTriggerTest "
                    >
                        <div class="field py-3">
                            <label for="simulation_time" class="label">What date & time should we simulate?</label>
                            <p class="control has-icons-left">
                                <xero-datetime id="simulation_time" class="input" value="now" name="simulation_time"></xero-datetime>
                                <span class="icon is-small is-left"><i class="fa-solid fa-clock"></i></span>
                            </p>
                        </div>

                        <button class="button is-info" type="submit">Run Simulation</button>
                    </confirm-form>
                </div>
            </modal>
        </div>



        <div v-else-if=" triggerType === 'manual' ">
            <confirm-form
                method="POST"
                text="This will simulate the trigger in order to test if it is working. No permanent actions will result from this test."
                :action=" routeTriggerTest "
            >
                <button class="button is-info" type="submit">Run Simulation</button>
            </confirm-form>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Trigger-Simulation',
    props: {
        triggerName: {
            type: String,
            required: true
        },
        triggerType: {
            type: String,
            required: true
        },
        routeTriggerTest: {
            type: String,
            required: true
        },
        triggerConfig: {
            type: Object,
            required: false
        },
    },
    data() {
        return {
            updatedData: [{property: '', value: ''}]
        };
    },
    methods: {
        addUpdatedProperty() {
            this.updatedData.push({property: '', value: ''});
        },
        updateUpdatedData(i) {
            this.updatedData[i].value = '';
        }
    }
}
</script>
